// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"8cea1c62","207":"0e54b69c","216":"8d6b8626","796":"fe57dbb4","897":"6e6abd95"}[chunkId] + ".chunk.css";
};